import * as giftExchangeRecordMolding from '../services/giftExchangeRecordMolding';

export default {
  namespace: 'giftExchangeRecordMolding',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
  },

  effects: {
    //商品管理一览列表
    *getQueryOrderPage({ payload: { values } }, { call, put }) {
      const response = yield call(
        giftExchangeRecordMolding.getQueryOrderPage,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          queryOrderPage: response?.data,
        },
      });
    },

    *deleteGift({ payload: { values }, callback }, { call }) {
      const res = yield call(giftExchangeRecordMolding.deleteGift, values);
      callback(res);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
